import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=0b78a7be&scoped=true&"
import script from "./ShippingInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInfo.vue?vue&type=style&index=0&id=0b78a7be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78a7be",
  null
  
)

export default component.exports